export const validation = {
  titleMaxChar: 100,
  paragraphMaxChar: 2000,
  images: {
    max: 3, 
    min: 1
  }
}
